import type * as React from 'react';
import { get } from '@Domain/Api';
import informationModesFetched, {
	type InformationModesFetchedAction,
	type InformationModesFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/informationModesFetched';
import informationModesFetchFailed, {
	type InformationModesFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/informationModesFetchFailed';
import type FetchInformationModes from '@Application/SubjectTypeDefinitions/Queries/FetchInformationModes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = InformationModesFetchedAction | InformationModesFetchFailedAction;

export default (_query: FetchInformationModes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<InformationModesFetchedPayload>(
				`${parameters.api.host}/api/enums/information-modes`,
			);

			const action = informationModesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = informationModesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
